'use client';

import React, { createContext, useContext, useMemo } from 'react';
import type { Sport } from '@sharpr/types';

interface SportContextValue {
  sport: Sport;
}

const SportContext = createContext<SportContextValue | undefined>(undefined);

export function SportProvider({
  children,
  sport
}: {
  children: React.ReactNode;
  sport: Sport;
}) {
  // Stable value so same-sport navigations (e.g. /mlb → /mlb/slate, which re-render
  // this client layout via usePathname) don't re-render every useSport() consumer.
  const value = useMemo(() => ({ sport }), [sport]);
  return (
    <SportContext.Provider value={value}>
      {children}
    </SportContext.Provider>
  );
}

export function useSport(): Sport {
  const context = useContext(SportContext);
  if (context === undefined) {
    throw new Error('useSport must be used within a SportProvider');
  }
  return context.sport;
}
